module.exports = __webpack_public_path__ + "media/agent_3_yureru_roll.0bbf947d.mp3";